<template>
  <section class="section">
    <div class="colums">
      <div class="column is-paddingless">
        <h1 class="title">Expenses</h1>
      </div>
    </div>

    <div class="box">
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Category</label>
            <div
              class="select is-fullwidth"
              v-bind:class="{'is-danger': $v.categoryId.$error}"
            >
              <select
                v-model="$v.categoryId.$model"
              >
                <option :value="null" selected="selected">Choose category</option>
                <option
                  v-for="category in expenseCategories"
                  :value="category.id"
                  v-bind:key="category.id"
                >
                  {{ category.name }}
                </option>
              </select>
            </div>
            <p v-if="$v.categoryId.$error" class="help is-danger">This value is invalid</p>
          </div>
        </div>

        <div class="column">
          <div class="field">
            <label class="label">Name</label>
            <input
              v-model="$v.name.$model"
              class="input"
              v-bind:class="{ 'is-danger': $v.name.$error }"
              type="text"
              placeholder="Name"
            >
            <p v-if="$v.name.$error" class="help is-danger">This value is invalid</p>
          </div>
        </div>

        <div class="column">
          <div class="field">
            <label class="label">Price</label>
            <input
              v-model="$v.total.$model"
              class="input"
              v-bind:class="{ 'is-danger': $v.total.$error }"
              type="text"
              inputmode="decimal"
              placeholder="Price"
            >
            <p v-if="$v.total.$error" class="help is-danger">This value is invalid</p>
          </div>
        </div>

        <div class="column">
          <div class="field">
            <label class="label">Date</label>
            <input
              v-model="$v.date.$model"
              class="input"
              v-bind:class="{ 'is-danger': $v.date.$error }"
              type="datetime-local"
              placeholder="Date"
              step="1"
            >
            <p v-if="$v.date.$error" class="help is-danger">This value is invalid</p>
          </div>
        </div>

        <div class="column">
          <div class="field">
            <label class="label">Save</label>
            <button
              class="button is-primary is-fullwidth "
              @click="save"
              :disabled="$v.$invalid"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <div class="table-container">
          <table class="table is-bordered is-striped is-fullwidth">
            <thead>
            <tr>
              <th class="iterator">#</th>
              <th class="date">Date</th>
              <th class="category">Category</th>
              <th class="name">Name</th>
              <th class="total">Total</th>
              <th class="actions">Actions</th>
            </tr>
            </thead>
            <tbody>
            <expenses-table-row
              v-for="(row, index) in expenses"
              :initial-row="row"
              :index="index"
              v-bind:key="row.id"
              v-on:refetch-list="$apollo.queries.expenses.refetch()"
            />
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from 'moment';
import {
  required,
  decimal,
  integer,
  alphaNum,
} from 'vuelidate/lib/validators';
import ExpensesTableRow from '../components/expense/ExpensesTableRow.vue';
import CREATE_EXPENSE from '@/graphql/expenses/createExpense.gql';
import EXPENSE_CATEGORIES from '@/graphql/expense-categories/expenseCategories.gql';
import EXPENSES from '@/graphql/expenses/expenses.gql';

export default {
  name: 'Expenses',
  components: { ExpensesTableRow },
  data() {
    return {
      expenseCategories: null,
      expenses: null,
      categoryId: null,
      name: null,
      total: null,
      date: moment().format(moment.HTML5_FMT.DATETIME_LOCAL),
    };
  },

  // Fix for localisation where phone keyboard has comma instead of dot.
  watch: {
    total(val) {
      this.total = val.replace(/,/g, '.');
    },
  },

  validations: {
    categoryId: {
      required,
      integer,
    },
    name: {
      required,
      alphaNum,
    },
    total: {
      required,
      decimal,
    },
    date: {
      required,
    },
  },
  apollo: {
    expenseCategories: EXPENSE_CATEGORIES,
    expenses: {
      query: EXPENSES,
      variables() {
        return {
          carId: this.$route.params.id,
        };
      },
    },
  },
  methods: {
    save() {
      this.$apollo.mutate({
        mutation: CREATE_EXPENSE,
        variables: {
          categoryId: this.categoryId,
          carId: this.$route.params.id,
          name: this.name,
          total: this.total,
          date: moment(this.date).format('YYYY-MM-DD HH:mm:ss'),
        },
      })
        .then(() => {
          this.categoryId = null;
          this.categoryId = null;
          this.name = null;
          this.total = null;

          this.$toasted.success('Data saved!');
          this.$apollo.queries.expenses.refetch();
        })
        .catch((error) => {
          this.$toasted.error(error);
        });
    },
  },
};
</script>

<style scoped>
.iterator {
  width: 5%;
  min-width: 50%;
}
.date {
  width: 15%;
  min-width: 200px;
}
.category {
  width: 15%;
  min-width: 200px;
}
.name {
  width: 45%;
  min-width: 450px;
}
.total {
  width: 10%;
  min-width: 150px;
}
.actions {
  width: 10%;
  min-width: 100px;
}
</style>
